"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
function getHostOrUrlParts(HostOrUrl) {
  var protocol, host, port, path;
  if (HostOrUrl.includes('://')) {
    ;
    var _HostOrUrl$split = HostOrUrl.split('://');
    var _HostOrUrl$split2 = (0, _slicedToArray2["default"])(_HostOrUrl$split, 2);
    protocol = _HostOrUrl$split2[0];
    HostOrUrl = _HostOrUrl$split2[1];
  } else {
    protocol = 'https';
    HostOrUrl = HostOrUrl.replace(/\/$/, '');
  }
  if (HostOrUrl.includes('/')) {
    var splits = HostOrUrl.split('/');
    var _ref = [splits[0], '/' + splits.slice(1).join('/')];
    host = _ref[0];
    path = _ref[1];
  } else {
    // assume host only
    path = '';
    host = HostOrUrl;
  }
  if (host.includes(':')) {
    var _splits = host.split(':');
    if (_splits.length > 2) {
      throw new Error("Too many ':' to get host and port: ".concat(host));
    }
    ;
    var _ref2 = [_splits[0], parseInt(_splits[1])];
    host = _ref2[0];
    port = _ref2[1];
  } else {
    if (protocol === 'http') {
      port = 80;
    } else if (protocol === 'https') {
      port = 443;
    } else {
      throw new Error("Could not infer port from unknown protocol ".concat(protocol));
    }
  }
  return {
    protocol: protocol,
    host: host,
    port: port,
    path: path
  };
}
/**
 * Support passing data to querystring when method is GET.
 */
var HttpAbstract = /*#__PURE__*/function () {
  function HttpAbstract() {
    (0, _classCallCheck2["default"])(this, HttpAbstract);
  }
  (0, _createClass2["default"])(HttpAbstract, [{
    key: "request",
    value: function () {
      var _request = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _len,
          _ref3,
          _key,
          method,
          url,
          data,
          opts,
          coreOpts,
          _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              for (_len = _args.length, _ref3 = new Array(_len), _key = 0; _key < _len; _key++) {
                _ref3[_key] = _args[_key];
              }
              method = _ref3[0], url = _ref3[1], data = _ref3[2], opts = _ref3[3];
              if (method === 'GET' && data && Object.keys(data).length > 0) {
                url += '?' + new URLSearchParams(data).toString();
              }
              coreOpts = Object.assign(Object.assign({
                method: method,
                data: method === 'GET' ? null : data
              }, opts), getHostOrUrlParts(url));
              _context.next = 6;
              return this.httpRequest(coreOpts);
            case 6:
              return _context.abrupt("return", _context.sent);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function request() {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }, {
    key: "get",
    value: function get() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return this.request.apply(this, ['GET'].concat(args));
    }
  }, {
    key: "post",
    value: function post() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return this.request.apply(this, ['POST'].concat(args));
    }
  }]);
  return HttpAbstract;
}();
exports["default"] = HttpAbstract;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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